import React from 'react';
import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import app_list from './app.list';
import app_detail from './app.detail';

/**
 *   Create index file
 */

export default function Apps() {
  let {
    slug = 'list'
  } = useParams();
  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = app_list;
      break;
    case 'view':
      ActualPage = app_detail;
      break;
    default:
      ActualPage = Theme404;
      break;
  }
  return <>{<ActualPage />}</>;
}